import axios from 'axios';

const api = axios.create({
  baseURL: 'https://amzmp.com.br/cliente/franceschi/lp/lp/recebe-lp-priscila.php',
  // baseURL: 'https://drapriscilarocco.com.br/backend',
  // baseURL: 'http://localhost/backend', // desenvolvimento local com PHP
});

export default api;
